var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10252_2028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34.5714,
    height: 34.5714,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 34.5714 3.02233e-06)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10252_2028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.307 27.3711C22.6358 27.3711 24.6344 26.6148 26.303 25.1023C27.9715 23.5898 28.8058 21.7052 28.8058 19.4485C28.8058 17.1917 27.9715 15.3071 26.303 13.7946C24.6344 12.2821 22.6358 11.5259 20.307 11.5259L11.232 11.5259L14.9772 7.78061L12.9606 5.76395L5.75818 12.9663L12.9606 20.1687L14.9772 18.152L11.232 14.4068L20.307 14.4068C21.8195 14.4068 23.1339 14.887 24.2503 15.8473C25.3667 16.8076 25.9249 18.008 25.9249 19.4485C25.9249 20.8889 25.3667 22.0893 24.2503 23.0497C23.1339 24.01 21.8195 24.4901 20.307 24.4901L10.0796 24.4901L10.0796 27.3711L20.307 27.3711Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.112ebc2410b85da0a3beceb4a5f1b401.svg";
export { ForwardRef as ReactComponent };